import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/ReshipmentConstants'
import { sortColumnByKey } from '../utils/sort'
import { normalizeReshipments } from '../utils/normalize'

export const resetReshipmentFlow = () => dispatch => dispatch({ type: c.RESET_RESHIPMENT_FLOW })

export const fetchReshipmentSummary = orgId => async (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current
  const config = {
    method: 'GET',
    url: `${Config.API_URL}/orders/organizations/${orgId}/education-periods/${educationPeriodCd}/reshipment/summary`,
  }
  try {
    dispatch({ type: c.FETCH_RESHIPMENT_SUMMARY_PENDING, payload: { orgId, educationPeriodCd } })
    const {
      data: { reshipmentOrders },
    } = await axios.request(config)
    const testWindows = Object.keys(reshipmentOrders)
    const normalizedData = {}
    testWindows.forEach(testWindow => {
      normalizedData[testWindow] = normalizeReshipments(
        sortColumnByKey(reshipmentOrders[testWindow], ['name', 'description'], ['asc', 'asc'], true)
      )
    })
    dispatch({
      type: c.FETCH_RESHIPMENT_SUMMARY_FULFILLED,
      payload: {
        orgId,
        educationPeriodCd,
        reshipmentOrders: normalizedData,
      },
    })
  } catch (err) {
    // console.log('Reshipment Summary Error:', err)
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.FETCH_RESHIPMENT_SUMMARY_REJECTED, payload: errMsg })
  }
}

export const fetchSavedReshipmentItems = orgId => async (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current
  const config = {
    method: 'GET',
    url: `${Config.API_URL}/orders/organizations/${orgId}/education-periods/${educationPeriodCd}/reshipment/line-items`,
  }
  try {
    dispatch({ type: c.FETCH_SAVED_RESHIPMENT_ITEMS_PENDING })
    const { data } = await axios.request(config)
    const { reshipmentOrders, name = null, lastUpdated = null, status = null } = data
    dispatch({
      type: c.FETCH_SAVED_RESHIPMENT_ITEMS_FULFILLED,
      payload: { name, lastUpdated, status, reshipmentOrders }, //sortColumnByKey(data, ['name', 'description'], ['asc', 'asc'], true),
    })
  } catch (err) {
    // console.log('fetchSavedReshipmentItems Error:', err)
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.FETCH_SAVED_RESHIPMENT_ITEMS_REJECTED, payload: errMsg })
  }
}

export const updateReshipmentItem = (orgId, item) => async (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current
  try {
    dispatch({ type: c.RESHIPMENT_SAVE_PENDING, payload: { orgId, educationPeriodCd } })
    const { data } = await axios.put(
      `${Config.API_URL}/orders/organizations/${orgId}/education-periods/${educationPeriodCd}/reshipment-materials`,
      item //{ ...item, isNewItem: false }
    )
    const { reshipmentOrders, name = null, lastUpdated = null, status = null } = data
    dispatch({
      type: c.RESHIPMENT_SAVE_FULFILLED,
      payload: { name, lastUpdated, status, reshipmentOrders }, //sortColumnByKey(data, ['name', 'description'], ['asc', 'asc']),
    })
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.RESHIPMENT_SAVE_REJECTED, payload: errMsg })
  }
}

export const removeReshipmentItem = examDateType => async (dispatch, getState) => {}

export const addNewMaterial = examDateType => dispatch => {
  dispatch({
    type: c.ADD_NEW_MATERIAL,
    payload: {
      name: '',
      ancillaryCd: c.NEW_ITEM,
      examDateType,
      quantity: null,
      isNewItem: true,
    },
  })
}

export const selectNewMaterial =
  ({ name, ancillaryCd, examDateType }) =>
  dispatch => {
    dispatch({
      type: c.SELECT_NEW_MATERIAL,
      payload: {
        name,
        ancillaryCd,
        examDateType,
        quantity: null,
        reshipQuantity: 0,
        isNewItem: true,
      },
    })
  }

export const cancelNewMaterial = (testWindow, ancillaryCd) => dispatch => {
  dispatch({ type: c.CANCEL_ADD_NEW_MATERIAL, payload: { testWindow, ancillaryCd } })
}

export const finishedAddingNewMaterial = payload => dispatch => {
  dispatch({ type: c.FINISHED_ADDING_NEW_MATERIAL, payload })
}

export const fetchNonSecureMaterials = () => async dispatch => {
  const config = {
    method: 'GET',
    url: `${Config.API_URL}/orders/non-secure-ancillary-materials`,
  }
  try {
    dispatch({ type: c.FETCH_NON_SECURE_MATERIALS_PENDING })
    const { data } = await axios.request(config)
    // This service returns ancillaryCds are returned as integers, convert to strings
    const testWindows = Object.keys(data)
    const payloadData = {}
    testWindows.forEach(
      testWindow =>
        (payloadData[testWindow] = data[testWindow].map(item => {
          return {
            ...item,
            ancillaryCd: item.ancillaryCd.toString(),
          }
        }))
    )
    dispatch({
      type: c.FETCH_NON_SECURE_MATERIALS_FULFILLED,
      payload: payloadData,
    })
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.FETCH_NON_SECURE_MATERIALS_REJECTED, payload: errMsg })
  }
}

export const submitReshipmentOrder = orgId => async (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current
  try {
    dispatch({ type: c.RESHIPMENT_SUBMIT_PENDING, payload: { orgId, educationPeriodCd } })
    const { data } = await axios.post(
      `${Config.API_URL}/orders/organizations/${orgId}/education-periods/${educationPeriodCd}/reshipment/submission`
    )
    const { name, lastUpdated, status } = data
    await dispatch({
      type: c.RESHIPMENT_SUBMIT_FULFILLED,
      payload: {
        name,
        lastUpdated,
        status,
      },
    })
    await dispatch(fetchSavedReshipmentItems(orgId))
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.RESHIPMENT_SUBMIT_REJECTED, payload: errMsg })
  }
}

export const fetchApprovedReshipments = orgId => async (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current
  const config = {
    method: 'GET',
    url: `${Config.API_URL}/orders/organizations/${orgId}/education-periods/${educationPeriodCd}/approved-reshipment-materials`,
  }
  try {
    dispatch({ type: c.FETCH_APPROVED_RESHIPMENT_MATERIALS_PENDING })
    const { data } = await axios.request(config)
    dispatch({
      type: c.FETCH_APPROVED_RESHIPMENT_MATERIALS_FULFILLED,
      payload: data,
    })
  } catch (err) {
    const errMsg = getServerErrorMessage(err)
    dispatch({ type: c.FETCH_APPROVED_RESHIPMENT_MATERIALS_REJECTED, payload: errMsg })
  }
}
